import React, { useEffect, useState } from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { Card, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { captilizeString } from '../functionUtils';
import ImageBanner from './ImageBanner';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { getPcpDetails, setValueCleanUp, setPcpDetailsCleanUp } from '../../../redux/yourCareTeam/actions';
import ViewCareMember from './ViewCareMember';
import Label from '../type/Label';

const YourCareTeam = () => {
  const dispatch = useDispatch();
  const tenantLayouts = useSelector(state => state.tenant.tenantLayout);
  const memberAccountsFromStore = useSelector(
    state => state?.memberAccounts?.memberAccountsDetails
  );

  const storedValue = useSelector(state => state?.pcpDetails?.storedValue);

  const dependents = memberAccountsFromStore?.dependents || [];
  let allMembers = [...dependents];

  // Only add self if it exists
  if (memberAccountsFromStore?.self) {
    allMembers = [...allMembers, memberAccountsFromStore.self];
  }
  allMembers = allMembers.filter(Boolean); // Remove undefined/null
  usePageTitle(tenantLayouts.Careteam.pageTitle);
  const pcpDetails = useSelector(state => state?.pcpDetails?.data);

  let filteredPcpDetailsData =
    pcpDetails &&
    pcpDetails
      .filter(
        (v, i, a) =>
          a.findLastIndex(v2 => v2.subscriberId === v.subscriberId) ===
          i
      )
      .sort((a, b) => a.subscriberId - b.subscriberId);
  filteredPcpDetailsData = filteredPcpDetailsData.filter((a) => allMembers.some((b) => b.subscriberId == a.subscriberId));
  const [toggleViewCareMember, setToggleViewCareMember] = useState(false);
  const [selectedMember, setSelectedMember] = useState({});
  const [memberAccountHeader, setMemberAccountHeader] = useState({});
  const [memberName, setMemberName] = useState('');

  useEffect(() => {
    if (!(!Array.isArray(allMembers) || !allMembers.length)) {
      dispatch(setPcpDetailsCleanUp());

      allMembers.map(member => {
        if (member) {
          const { groupId, subscriberId, subscriberSuffix } = member;
          const memberAccountHeader = `${groupId}-${subscriberId}-${subscriberSuffix}`;
          setMemberAccountHeader(memberAccountHeader);
          dispatch(
            getPcpDetails(
              memberAccountHeader,
              localStorage.getItem('tenantHandle')
            )
          );
        }
      });
    }
  }, [memberAccountsFromStore]);

  const handleViewPhysician = (member, test) => {
    setToggleViewCareMember(!toggleViewCareMember);
    setSelectedMember(member);
    setMemberName(test);
  };

  const handleGoBackClick = () => {
    setToggleViewCareMember(!toggleViewCareMember);
  };

  useEffect(() => {
      storedValue &&
      filteredPcpDetailsData &&
      allMembers.length > 0 &&
      filteredPcpDetailsData.length > 0 &&
      filteredPcpDetailsData?.map(
        member =>
          (storedValue.subscriberId === member.subscriberId &&
           storedValue.subscriberSuffix === member.subscriberSuffix
          )&&
          handleViewPhysician(
            member,
            `${captilizeString(
              allMembers.find(
                item => item.subscriberSuffix === member.subscriberSuffix &&
                item.subscriberId === member.subscriberId
              ).firstName
            )} ${captilizeString(
              allMembers.find(
                item => item.subscriberSuffix === member.subscriberSuffix &&
                item.subscriberId === member.subscriberId
              ).lastName
            )}`
          )              
      );
   
      return(() => {!toggleViewCareMember && setValueCleanUp();});
  }, [storedValue]);

  const findPcpForMember = m =>
  filteredPcpDetailsData.find(
    p =>
      p.subscriberId === m.subscriberId &&
      p.subscriberSuffix === m.subscriberSuffix
  );

  {/*return <div>Care Team</div>;  */}
  return (
    <>
      <ImageBanner
        banner="BenefitsCoveredMembersBanner"
        title={<Label id='careTeamText'/>}
        className="careTeamHeaderText"
      ></ImageBanner>
      {!toggleViewCareMember ? (
        <div className="CareTeamLayoutSection">
          <Typography variant="h4" className="care-team-header">
            <Label id='careTeamForAll'/>
          </Typography>
          <div className="CareTeamCardSection">
            <Card className="care-team-card">
              {allMembers && allMembers.length > 0 ? (
                allMembers?.map((member, index) => {
                  const pcp = findPcpForMember(member) || {};
                  const fullName = `${captilizeString(
                             member.firstName
                  )} ${captilizeString(member.lastName)}`;
                  const isSelf =
                    memberAccountsFromStore?.self &&
                    member.subscriberId === memberAccountsFromStore.self.subscriberId &&
                    member.subscriberSuffix === memberAccountsFromStore.self.subscriberSuffix;
                    return (
                    <div
                    key={index}
                    id="care-team-card"
                    className="careTeamCardPCP"
                    onClick={() =>
                      handleViewPhysician(
                        pcp,
                        fullName
                      )
                    }
                  >
                    <div className="care-team-details">
                      <Typography variant="body1">
                        {fullName}
                      </Typography>
                      <Typography
                        variant="body1"
                        className="care-member-relationship"
                      >{captilizeString(isSelf ? 'Self' : 'Dependent')}
                      </Typography>
                    </div>
                    <div className="care-team-details">
                      {pcp.providerName ? (
                        <>
                          <Typography variant="body1">
                              <Label id="PCPLabel" />                          
                          </Typography>
                          <Typography
                            variant="body1"
                            className="care-team-physician-name"
                          >
                            {pcp.providerName}
                          </Typography>
                        </>
                      ) : (
                        <Typography
                          variant="body1"
                          className="care-team-physician-name choosePcp"
                        >
                          Choose a PCP
                        </Typography>
                      )}
                    </div>
                    <KeyboardArrowRightIcon
                      className="claimNavigateIcon"
                      color="secondary"
                      id="claim-naviage"
                    ></KeyboardArrowRightIcon>
                  </div>
                );
              })
              ) : (
                <Typography variant="h6">No members to display.</Typography>
              )}
            </Card>
          </div>
        </div>
      ) : (
        <ViewCareMember
          selectedMember={{selectedMember: selectedMember, selfMember: filteredPcpDetailsData.find(item => item.subscriberId == allMembers.find(item => item).subscriberId)}}
          memberAccountHeader={memberAccountHeader}
          name={memberName}
          handleGoBackClick={() => handleGoBackClick}
        />
      )}
    </>
  );

};
export default YourCareTeam;